import React, { Component } from "react";
import ReactDom from "react-dom";
import { checkIsIe10 } from "./tools";

import classNames from "classnames";
import { observer, inject } from "mobx-react";
import { withRouter } from "react-router-dom";
import { Tag, Dropdown, Icon, Tooltip, Menu, Tabs } from "antd";
const { SubMenu } = Menu;

import config from "config/Config";
import styles from "./PageTabsLess.less";
import { YxAction, YxText } from "yx-widget";
import utils from "utils";
import CubeI8N from "utils/cubeI8N";
import routerCache from "utils/routerCache";
import { get } from "lodash";
import { bool } from "prop-types";

const webConfig = { indexPath: config.homePath || "/" };

// 配置参数
// showTabs {bool} false 显示标题

/*
// 模拟全局路由配置对象，
const routerCfg = {
  '/': { name: '首页' },
  '/product': { name: '产品列表' },
  '/search': { name: '产品搜索' },
  '/user': { name: '用户列表' },
  '/info': { name: '用户详情' }
};

// 通过 pathname 获取 pathname 对应到路由描述信息对象
const getTitleByPathname = (pathname) => {
  return routerCfg[pathname];
}
*/

@withRouter
@inject("AppStore")
// 将组件设置为响应式组件，成为观察者，以便响应被观察数据的变化
@observer
export default class PageTabs extends Component {
  static unListen = null;
  static defaultProps = {
    initialValue: [],
  };
  constructor(props) {
    super(props);
    this.state = {
      // 当前路由对应到 pathname 如/user /product
      currentPageName: [],
      // tabs所有到所有页签  如['/user', '/product']
      refsTag: [],
      // 每个页签对应的路由参数 如{'/user': '?a=1&b=2'}
      searchMap: {},
    };
    this.stores = this.props.AppStore;
    this.handleMenuClick = this.handleMenuClick.bind(this);
    this.props.history.closePageTabs = this.handleClose
  }

  // 通过路径，获取标题name，如{'/': {name: '首页'}, ...}
  getTitleByPathname(pathname) {
    let tabTitle = this.stores.state.routerCfg[pathname];
    return tabTitle;
  }

  async componentWillMount() {
    this.CubeI8N = new CubeI8N();
  }

  // 组件挂载，已插入真实DOM
  componentDidMount() {
    const targetMount = utils.getQueryString("target");

    if (this.unListen) {
      this.unListen();
      this.unListen = null;
    }
    // 监听路由切换事件
    this.unListen = this.props.history.listen((_location) => {
      const target = utils.getQueryString("target");
      const { pathname, search } = _location;

      if (this.didUnMounted) {
        return;
      }
      if (this.notListenOnce) {
        this.notListenOnce = false;
        return;
      }
      if (pathname === "/" || !this.getTitleByPathname(pathname)) {
        this.setState({
          currentPageName: "",
        });
        return;
      }
      const newRefsTag = [...this.state.refsTag];
      const currentPathname = target ? pathname + search : pathname;
      if (newRefsTag.indexOf(currentPathname) === -1) {
        newRefsTag.push(currentPathname);
      }
      this.state.searchMap[currentPathname] = _location.search;
      this.setState({
        currentPageName: currentPathname,
        refsTag: newRefsTag,
      });
      // 假如是新的 导航item 添加进来,需要在 添加完成后调用 scrollIntoTags
      clearTimeout(this.tagChangeTimerId);
      this.tagChangeTimerId = setTimeout(() => {
        this.scrollIntoTags(currentPathname);
      }, 100);
    });
    const { pathname, search } = this.props.location;
    const currentPathname = targetMount ? pathname + search : pathname;
    // 解决刷新后的默认显示问题
    if (0 === this.state.refsTag.length) {
      let tSearchMap = {};
      tSearchMap[currentPathname] = search;
      this.setState({
        currentPageName: currentPathname,
        refsTag: [currentPathname],
        searchMap: tSearchMap,
      });
    }
    this.scrollIntoTags(currentPathname);
  }

  componentWillUnmount() {
    this.didUnMounted = true;
    if (this.unListen) {
      this.unListen();
      this.unListen = null;
    }
  }

  scrollIntoTags(pathname) {
    let dom;
    try {
      // eslint-disable-next-line react/no-find-dom-node
      dom = ReactDom.findDOMNode(this).querySelector(
        `[data-key="${pathname}"]`
      );
      if (dom === null) {
        // 菜单 还没有加入 导航条(横)
      } else {
        // 菜单 已经加入 导航条(横)
        dom.scrollIntoView(false);
      }
    } catch (e) {
      // console.error(e);
    }
  }

  handleClose = (e, tag) => {
    if (!!e) {
      // 阻止事件冒泡
      e.stopPropagation();
      e.nativeEvent.stopImmediatePropagation();
    }
    const { pathname } = this.props.location;
    const { history } = this.props;
    let { currentPageName } = this.state;
    const { searchMap } = this.state;

    if (get(config, "routerCache.isPageTabsDe") == true) {
      //是否关闭的时候清空当前页缓存
      setTimeout(() => {
        routerCache.deleteCache(tag);
      }, 300);
    }
    // const newRefsTag = [...this.state.refsTag.filter(t => t !== tag)];
    // if (currentPageName === tag) {
    //   currentPageName = this.state.refsTag[this.state.refsTag.indexOf(tag) - 1];
    // }
    // this.setState({
    //   currentPageName,
    //   refsTag: newRefsTag,
    // });
    // if (pathname !== currentPageName) {
    //   this.notListenOnce = true;
    //   history.push({
    //     pathname: currentPageName,
    //     search: searchMap[currentPageName],
    //   });
    // }

    // 首先尝试激活左边的, 再尝试激活右边的
    let nextTabKey = this.state.currentPageName;

    if ("" + this.state.currentPageName === "" + tag) {
      let currentTabIndex = -1;
      this.state.refsTag.forEach((pane, i) => {
        if (pane === tag) {
          currentTabIndex = i;
        }
      });

      // 如果当前tab左边还有tab, 就激活左边的
      if (currentTabIndex > 0) {
        nextTabKey = this.state.refsTag[currentTabIndex - 1];
      }
      // 否则就激活右边的tab
      else if (currentTabIndex === 0 && this.state.refsTag.length > 1) {
        nextTabKey = this.state.refsTag[currentTabIndex + 1];
      }
      // 其实还有一种情况, 就是只剩最后一个tab, 但这里不用处理
    }
    const newRefsTag = [...this.state.refsTag.filter((t) => t !== tag)];
    this.setState(
      {
        currentPageName: nextTabKey,
        refsTag: newRefsTag,
      },
      () => {
        // 如果设置了关闭页签的钩子回调函数，则页签关闭时调用
        if (this.stores.state.hookCbf) {
          this.stores.state.hookCbf();
        }
      }
    );

    if (pathname !== nextTabKey) {
      this.notListenOnce = true;
      history.push({
        pathname: nextTabKey,
        search: searchMap[nextTabKey],
      });
    } else {
      this.notListenOnce = true;
      history.push({
        pathname: "/",
        search: searchMap["/"],
      });
    }
  };

  handleClickTag = (tag, e) => {
    let path = tag;
    if (e && e.target.tagName.toLowerCase() === "i") {
      return;
    }
    if (tag !== this.state.currentPageName) {
      path = path.split("?")[0]; /* 提取路由名称 */
      this.props.history.push({
        pathname: path,
        search: this.state.searchMap[tag]
          ? this.state.searchMap[tag].replace(/from=[^&]+&?/, "")
          : undefined,
      });
    }
  };

  handleMenuClick = (e) => {
    const eKey = e.key;
    let currentPathname = this.props.location.pathname;
    const { refsTag } = this.state;

    if (0 === refsTag.length) {
      return false;
    }

    if (eKey == "1" || eKey == "2") {
      if (get(config, "routerCache.isPageTabsDe") == true) {
        //是否关闭的时候清空当前页缓存
        setTimeout(() => {
          routerCache.deleteCache(0);
        }, 300);
      }
    }

    let newRefsTag;
    if (eKey === "1") {
      newRefsTag = "/";
      currentPathname = "/";
      this.props.history.push({
        pathname: currentPathname,
        search: this.state.searchMap[currentPathname],
      });
      newRefsTag = [webConfig.indexPath];
      if (currentPathname !== webConfig.indexPath) {
        newRefsTag.push(currentPathname);
      }
    } else if (eKey === "2") {
      newRefsTag = [webConfig.indexPath];
      if (currentPathname !== webConfig.indexPath) {
        newRefsTag.push(currentPathname);
      }
    } else {
      this.handleClickTag(eKey);
      return;
    }
    if (currentPathname !== this.state.currentPageName) {
      this.props.history.push({
        pathname: currentPathname,
        search: this.state.searchMap[currentPathname],
      });
    }
    this.setState({
      refsTag: newRefsTag,
    });
  };

  renderTag = (pathname, currentPageName, title) => {
    const isLongTag = title.length > 30;
    const iconParam = {
      className: "close-icon",
      type: "iconguanbi",
      iconfont: true,
      onClick: (e) => this.handleClose(e, pathname),
    };
    const DOM = (
      <Tag
        key={pathname}
        data-key={pathname}
        className={classNames(styles.tag, {
          [styles.active]: pathname === currentPageName,
        })}
        onClick={(e) => this.handleClickTag(pathname, e)}
      >
        <span className={styles.icon} />
        {isLongTag ? `${title.slice(0, 30)}...` : title}
        {this.state.refsTag.length == 1 ? (
          <span
            style={{ width: "4px", display: "inline-block", opacity: "0" }}
          ></span>
        ) : (
          ""
        )}
        {/* 设计特殊要求当一个时候加宽 */}
        {this.state.refsTag.length > 1 && <YxText.Icon {...iconParam} />}
      </Tag>
    );
    return DOM;
  };

  render() {
    let { currentPageName, refsTag } = this.state;
    const { className, style, showTabs } = this.props;
    const cls = classNames(styles["router-tabs"], className);
    const isIe10 = checkIsIe10();
    const tags = refsTag.map((pathname, index) => {
      if (!pathname) {
        console.error("your page has incorrect syntax！");
        return <span>&nbsp;</span>;
      }
      currentPageName = currentPageName ? currentPageName : webConfig.indexPath;
      const splitPathname = pathname.split("?")[0];
      const routeInfo = this.getTitleByPathname(splitPathname); // 这里假设每个pathname都能获取到指定到页面名称
      let title = routeInfo ? routeInfo.name : "404";
      const isLongTag = title.length > 30;
      const tagElem = this.renderTag(pathname, currentPageName, title);
      return isLongTag ? (
        <Tooltip title={title} key={`tooltip_${pathname}`}>
          {tagElem}
        </Tooltip>
      ) : (
        tagElem
      );
    });

    this.tags = tags;
    /* eslint-disable */
    if (showTabs == false) {
      const getTitle = () => {
        const routeInfo = this.getTitleByPathname(currentPageName); // 这里假设每个pathname都能获取到指定到页面名称
        const title = routeInfo ? routeInfo.name : "404";
        return title;
      };
      return <div className={styles.pageTitle}>{getTitle()}</div>;
    } else {
      return (
        <div
          className={cls}
          style={{
            ...style,
            // height: '40px',
            // maxHeight: '40px',
            // lineHeight: '40px',
            // marginRight: '-12px',
          }}
        >
          <div
            style={{
              flex: "1",
              height: "39px",
              position: "relative",
              overflow: "hidden",
              padding: "0px 0px",
              borderBottom: "3px #f3f4f6 solid",
              // boxShadow: "0px 2px 3px rgba(51, 65, 80, 3%)",
            }}
          >
            <div
              style={{
                position: `${isIe10 ? "inline-block" : "absolute"}`,
                whiteSpace: "nowrap",
                marginRight: `${isIe10 ? "-3px" : 0}`,
                width: "100%",
                top: "0px",
                padding: "0px 10px 0px 10px",
                overflowX: "auto",
                overflowY: "hidden",
                clear: "both",
              }}
            >
              {tags}
            </div>
          </div>
          <div className="close-box">
            <Dropdown
              overlay={
                <Menu
                  onClick={this.handleMenuClick}
                  className={`close-box-mune`}
                >
                  <Menu.Item key="1">
                    {this.CubeI8N.getString("basic.code-001")}
                  </Menu.Item>
                  <Menu.Item key="2">
                    {this.CubeI8N.getString("basic.code-002")}
                  </Menu.Item>
                  <SubMenu
                    className={`close-box-sub-menu`}
                    title={this.CubeI8N.getString("basic.code-003")}
                  >
                    {tags.map((item) => (
                      <Menu.Item key={item.key}>
                        {item.props.children}
                      </Menu.Item>
                    ))}
                  </SubMenu>
                </Menu>
              }
            >
              <YxAction styleType="icon" iconfont={true} type="icongengduo" />
            </Dropdown>
          </div>
        </div>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/widget/PageTabs/PageTabsView.js